import moment from "moment";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import LogoOlin from "../../../assets/icons/logoOlin.png";

const toThousandFormatapi = (number) => {
  return (number ? number : 0).toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });
};

const paperHeight = 140;

// Print invoice template is adjusted for printing on continuous form paper of size 24.3 x 14 cm on potrait
// before printing, adjust left margin to 0.21 inch and right margin to 0.5 inch from print dialog
const PrintInvoiceOms = ({ dataDetail }) => {
  const companyName = localStorage.getItem("company_name");
  var elem = document.getElementById("print-area-oms");

  // function to round each section to a multiple of paper height
  // window.addEventListener("load", function (event) {
  if (elem && dataDetail) {
    var rect = elem.getBoundingClientRect();
    var tempHeight =
      Math.floor((rect.height * 0.2 + paperHeight) / paperHeight) * paperHeight;
    elem.style.height = tempHeight + "mm";
    elem.style.minHeight = tempHeight + "mm";
  }
  // });

  const newHeight = () => {
    if (elem) {
      var rect = elem.getBoundingClientRect();
      return (
        Math.floor((rect.height * 0.2 + paperHeight) / paperHeight) *
        paperHeight
      );
    }
  };

  return (
    <>
      <style>{`@media print {
        @page {
          size: 216mm 280mm potrait; 
        
        }
        body {
          margin:0 !important; 
          padding:0 !important;
        }
        margin: 0 !important;
      }`}</style>
      {/* <div className="h-[140mm] bg-repeat-y">
        <img
          src={LogoOlin}
          className=" -z-50 opacity-10 max-h-[130mm] w-full max-w-[150mm] object-contain fixed top-0 bottom-0 left-0 right-0 mx-auto my-auto"
        />
      </div> */}
      {dataDetail
        ? dataDetail.map((item, i) => {
          return (
            <div
              className={`min-h-[140mm] max-h-[${newHeight()}] text-[9px] h-fit`}
              id="print-area-oms"
              key={i}
            >
              <div className="w-full mb-2 flex justify-between items-center text-[18px] font-bold">
                <p>{companyName?.toUpperCase()}</p>
                <p>FAKTUR</p>
              </div>
              <div className="grid grid-cols-3 gap-2">
                <div className="w-full">
                  <div className="flex items-start gap-2">
                    <div className="w-full">No. SIA</div>
                    <div className="w-full">: {item.customer?.sia}</div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-full">Alamat</div>
                    <div className="w-full">: {item.customer?.address}</div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="flex items-start gap-2">
                    <div className="w-full">Ryn/Sales</div>
                    <div className="w-full">: {item.sales}</div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-full">No. Faktur</div>
                    <div className="w-full">: {item.invoice_number}</div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-full">No. Ref</div>
                    <div className="w-full">: {item.ref_number}</div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-full">Kode Debitur</div>
                    <div className="w-full">: {item.debitur_code}</div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-full">Order No.</div>
                    <div className="w-full">: {item.order_number}</div>
                  </div>
                </div>
                <div className="w-full">
                  <p>Kepada Yth.</p>
                  <div className="flex items-start gap-2">
                    <div className="w-full">Nama Bidan</div>
                    <div className="w-full">
                      : {item.customer?.midwife_name}
                    </div>
                  </div>
                  <div className="flex items-start gap-2 mb-4">
                    <div className="w-full">Alamat</div>
                    <div className="w-full">
                      : {item.shipment.shipment_address}
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-full">Tgl.</div>
                    <div className="w-full">
                      : {moment(item.purchase_date).format("DD/MM/YYYY")}
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-full">Tgl. Jatuh Tempo</div>
                    <div className="w-full">
                      : {moment(item.expired_date).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </div>
              </div>

              <div className="">
                <table className="w-full my-2 text-[9px]">
                  <tbody>
                    <tr>
                      <td className="p-1 border-2 text-center font-bold">
                        No
                      </td>
                      <td className="p-1 border-2 text-center font-bold">
                        Kode Produk
                      </td>
                      <td className="p-1 border-2 text-center font-bold">
                        Nama Produk
                      </td>
                      <td className="p-1 border-2 text-center font-bold">
                        No. Batch
                      </td>
                      <td className="p-1 border-2 text-center font-bold">
                        Exp Date
                      </td>
                      <td className="p-1 border-2 text-center font-bold">
                        Qty
                      </td>
                      <td className="p-1 border-2 text-center font-bold">
                        Satuan
                      </td>
                      <td className="p-1 border-2 text-center font-bold">
                        Harga
                      </td>
                      <td className="p-1 border-2 text-center font-bold">
                        Diskon
                      </td>
                      <td className="p-1 border-2 text-center font-bold">
                        Jumlah Harga
                      </td>
                    </tr>
                    {item.product.map((prod, i) => {
                      return (
                        <tr className="text-center" key={i}>
                          <td className="p-1 border-2 text-center">
                            {i + 1}
                          </td>
                          <td className="p-1 border-2 text-center">
                            {prod.product_code}
                          </td>
                          <td className="p-1 border-2">
                            {prod.product_name}
                          </td>
                          <td className="p-1 border-2 text-center">
                            {prod.batch_no}
                          </td>
                          <td className="p-1 border-2 text-center">
                            {moment(prod.expired_date)?.format("MM/YYYY")}
                          </td>
                          <td className="p-1 border-2 text-center">
                            {prod.quantity}
                          </td>
                          <td className="p-1 border-2 text-center">
                            {prod.uom}
                          </td>
                          <td className="p-1 border-2 text-right">
                            {toThousandFormatapi(
                              prod.price ? prod.price : 0
                            )}
                          </td>
                          <td className="p-1 border-2 text-center">
                            {prod.discount}%
                          </td>
                          <td className="p-1 border-2 text-right">
                            {toThousandFormatapi(
                              prod.total_price ? prod.total_price : 0
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan={8} rowSpan={5} className="align-top">
                        <div className="my-3">
                          <div className="flex gap-1 items-start mb-2">
                            <p className="font-bold mt-2">Terbilang:</p>
                            <p className="p-2 border-2 w-full mx-4">
                              {angkaTerbilang(
                                item?.payment?.total_payment
                              ).toUpperCase()}{" "}
                              RUPIAH
                            </p>
                          </div>
                          <div className="text-center w-1/2">
                            <p>
                              Produk-produk tsb telah diterima dengan baik
                            </p>
                            <p className="mb-[20mm]">Yang Menerima</p>
                            <p>{item.customer?.pharmacist_name || "N/A"}</p>
                            <p>NO. SIPB: {item.customer?.sipb || "-"}</p>
                          </div>
                        </div>
                      </td>
                      <td className="p-1 border-2">Jumlah</td>
                      <td className="p-1 border-2 text-right">
                        {toThousandFormatapi(
                          item?.payment?.product_sub_total
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-1 border-2">Potongan</td>
                      <td className="p-1 border-2 text-right">
                        {toThousandFormatapi(
                          item?.payment?.discount
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-1 border-2">PPN</td>
                      <td className="p-1 border-2 text-right">
                        {toThousandFormatapi((item?.payment?.product_sub_total) * 0.11)}
                      </td>
                    </tr>
                    {/* <tr>
                      <td className="p-1 border-2">Materai</td>
                      <td className="p-1 border-2 text-right">
                        {toThousandFormatapi(item.materai)}
                      </td>
                    </tr> */}
                    <tr>
                      <td className="p-1 border-2">Jumlah Bayar</td>
                      <td className="p-1 border-2 text-right">
                        {toThousandFormatapi(
                          item?.payment?.total_payment
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="font-bold w-full text-center">
                  Produk yang sudah dibeli tidak bisa dikembalikan
                </p>
              </div>
            </div>
          );
        })
        : null}
    </>
  );
};

export default PrintInvoiceOms;
